import { render, staticRenderFns } from "./DebtHelplineBanner.vue?vue&type=template&id=3f96a3b6&scoped=true"
import script from "./DebtHelplineBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./DebtHelplineBanner.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DebtHelplineBanner.vue?vue&type=style&index=0&id=3f96a3b6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f96a3b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f96a3b6')) {
      api.createRecord('3f96a3b6', component.options)
    } else {
      api.reload('3f96a3b6', component.options)
    }
    module.hot.accept("./DebtHelplineBanner.vue?vue&type=template&id=3f96a3b6&scoped=true", function () {
      api.rerender('3f96a3b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/modules/shared/components/display/DebtHelplineBanner.vue"
export default component.exports